import { CamelCaseLocation } from '@eventbrite/global-nav';
import { $FixMe } from '@eventbrite/ts-utils';
import React from 'react';
import { getSearchBarProps } from '../../../components/ConsumerHeader';
import { BasePage } from '../../base';
import { useAnalyticsAndMonitoring } from '../hooks/analytics';
import { useUpdatePageTitle } from '../hooks/dom';
import { useLocation } from '../hooks/queries/location';

export const CategoryBrowseBasePage: React.FunctionComponent<$FixMe> = (
    props,
) => {
    useUpdatePageTitle();
    useAnalyticsAndMonitoring();

    // Get the location for the global nav
    const { data: location } = useLocation();
    const searchBar = React.useMemo(() => {
        return getSearchBarProps({
            location: location as CamelCaseLocation,
        });
    }, [location]);

    return (
        <BasePage {...props} searchBar={searchBar}>
            {props.children}
        </BasePage>
    );
};
